import { GraphSchema } from '@camelot/server';

import { DayAvailability } from './day-availability';
import { MissionType } from './mission-type';
import { Role } from './role';

export interface Function {
  id: string;
  name: string;
  tenantId: number;
  roles: Role[];
  dayAvailabilities: DayAvailability[];
  missionTypes: MissionType[];
}

export interface FunctionCreationPayload {
  name: string;
  roleIds: string[];
  missionTypes: number[];
}

export interface FunctionModifierPayload {
  id: string;
  name: string;
  roleIds: string[];
  missionTypes: number[];
}

export const functionProps = new GraphSchema<Function>([
  'id',
  'name',
  'tenantId',
  'roles',
  'dayAvailabilities',
  'missionTypes',
]);
